import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation, Trans } from "react-i18next";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { ResizableBox } from "react-resizable";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import "@mdi/font/css/materialdesignicons.min.css";
import { Draggable } from "react-beautiful-dnd";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Divider from "@material-ui/core/Divider";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import { SizeMe } from "react-sizeme";

import { Bar, Line, Pie } from "react-chartjs-2";

const elementMappings = {
  BarChart: Bar,
  LineChart: Line,
  PieChart: Pie,
};

const styles = (theme) => ({
  sectionsType: {
    marginTop: 13,
    minWidth: 182,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  formGroup: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
});

export class ChartStepThree extends Component {
  state = {
    selectedDataNames: {},
    tableChartChoice: "Chart",
    selectedData: false,
    chart: {
      chartType: "BarChart",
      // colour: '#F44336',
      // strokeColour: '#F44336',
      colorRange: ["#F44336", "#607d8b"],
      opacity: 1,
      strokeWidth: 2,
      barWidth: 0.5,
      size: 5,
      xAxisTitle: "",
      yAxisTitle: "",
      yAxisTitlePosition: "end",
      xAxisTitlePosition: "end",
      title: "",
      data: null,
      dataHeaders: {},
    },
    edit: false,
  };
  componentDidMount() {
    if (this.props.edit && this.props.chart) {
      if (this.props.chart.chartType === "Table") {
        this.setState({ tableChartChoice: "Table" });
      }
      this.setState({
        selectedData: true,
        chart: {
          ...this.props.chart,
          dataHeaders: {
            x: this.props.chart.series.x,
            y: this.props.chart.series.y,
          },
        },
      });
      this.props.setNextDisabled(false);
    }
  }
  handleSelectChange = (event) => {
    this.setState(
      {
        chart: { ...this.state.chart, chartType: event.target.value },
      },
      () => {
        this.handleSetData();
      }
    );
  };
  returnChart = (chart) => {
    let Chart = elementMappings[this.props.chart.series.chartType];
    if (
      typeof Chart === "undefined" ||
      !this.props.chart.series.y ||
      !this.props.chart.series.x
    ) {
      return null;
    }
    let dataArray = [];
    let labelArray = [];
    this.props.chart.data.forEach((item) => {
      dataArray.push(item[this.props.chart.series.y]);
      labelArray.push(item[this.props.chart.series.x]);
    });

    let data = {
      labels: labelArray,
      datasets: [{ label: "", data: dataArray }],
    };

    return (
      <div
        style={{
          position: "relative",
          width: this.props.chart.width,
          height: this.props.chart.height,
        }}
      >
        <Chart
          data={data}
          options={{
            responsive: true,
            legend: { display: false },
            maintainAspectRatio: false,
          }}
        />
      </div>
    );
  };

  handleSelectedDataNameChange = (name) => (event) => {
    let chart = { ...this.state.chart };
    chart.dataHeaders[name] = event.target.value;
    if (chart.dataHeaders.x && chart.dataHeaders.y) {
      this.props.setNextDisabled(false);
    } else {
      this.props.setNextDisabled(true);
    }
    this.setState(
      {
        chart,
        selectedData: true,
      },
      () => {
        this.handleSetData();
      }
    );
  };
  handleSetData = () => {
    this.props.handleChartChange({
      ...this.props.chart,
      series: {
        ...this.state.chart,
        x: this.state.chart.dataHeaders.x,
        y: this.state.chart.dataHeaders.y,
      },
    });
  };
  getHeader = () => {
    var keys = this.props.usedKeys;
    if (Array.isArray(keys)) {
      return keys.map((key, index) => {
        return (
          <TableCell
            key={key}
            component={
              <Draggable draggableId={key + index} index={index}>
                {(dragProvided, dragSnapshot) => (
                  <div
                    ref={dragProvided.innerRef}
                    {...dragProvided.draggableProps}
                    {...dragProvided.dragHandleProps}
                  >
                    {this.props.t("report_column_" + key).toUpperCase()}
                    <span
                      className={`mdi mdi-drag-vertical`}
                      {...dragProvided.dragHandleProps}
                      style={{ fontSize: "1.5rem" }}
                    />{" "}
                  </div>
                )}
              </Draggable>
            }
          />
        );
      });
    }
  };
  renderRow = (props) => {
    return props.keys.map((key, index) => {
      let renderData;
      props.data[key] instanceof Object
        ? (renderData = JSON.stringify(props.data[key]))
        : (renderData = props.data[key]);
      return <TableCell key={index}>{renderData}</TableCell>;
    });
  };
  getRowsData = () => {
    var items = this.props.chart.data;
    var keys = this.props.usedKeys;
    return items.map((row, index) => {
      return (
        <TableRow key={index}>
          {this.renderRow({ key: index, data: row, keys: keys })}
        </TableRow>
      );
    });
  };
  onDragEnd = (result) => {
    if (!result.destination) return;
    let usedKeys = [...this.props.usedKeys];
    if (result.type === "top") {
      const [removed] = usedKeys.splice(result.source.index, 1);
      usedKeys.splice(result.destination.index, 0, removed);
      this.props.setUsedKeys(usedKeys);
    }
  };
  changeRadio = (name) => (event) => {
    if (event.target.value === "Table") {
      this.setState({ chart: { ...this.state.chart, chartType: "Table" } });
      this.props.handleChartChange({ ...this.props.chart, chartType: "Table" });
    } else {
      this.setState({
        chart: { ...this.state.chart, chartType: "BarChart" },
      });
      this.props.handleChartChange({
        ...this.props.chart,
        chartType: "BarChart",
      });
    }
    this.setState({
      [name]: event.target.value,
    });
  };
  chipClick = (index) => {
    this.setState({ chart: this.props.chart.series[index], edit: true });
  };
  editSeries = (index) => {
    this.props.editSeries(index, this.state.chart);
    this.setState({ edit: false });
  };
  componentDidUpdate() {
    this.nextStep();
  }
  nextStep = () => {
    this.state.selectedData || this.state.tableChartChoice === "Table"
      ? this.props.changeAvailableStep(3)
      : this.props.changeAvailableStep(2);
  };
  render() {
    const { classes, ...withoutClasses } = this.props;
    let table = this.state.tableChartChoice === "Table";
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            marginRight: 8,
          }}
        >
          <FormControl component="fieldset" className={classes.formControl}>
            <FormLabel component="legend">
              {this.props.t("report_chart_or_table")}
            </FormLabel>
            <RadioGroup
              style={{ display: "flex", flexDirection: "row" }}
              value={this.state.tableChartChoice}
              onChange={this.changeRadio("tableChartChoice")}
              aria-label="chart choice"
              name="customized-radios"
            >
              <FormControlLabel
                value="Table"
                id="report-as-table"
                control={<Radio />}
                label={this.props.t("report_table")}
              />
              <FormControlLabel
                value="Chart"
                id="report-as-chart"
                control={<Radio />}
                label={this.props.t("report_chart")}
              />
            </RadioGroup>
          </FormControl>
          {!table ? (
            <>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  {this.props.t("report_chart_type")}
                </InputLabel>
                <Select
                  MenuProps={{
                    style: { zIndex: 10002 },
                  }}
                  value={this.state.chart.chartType}
                  onChange={this.handleSelectChange}
                  inputProps={{
                    name: "chartType",
                    id: "chartType",
                  }}
                >
                  <MenuItem key="fontSize" value={"BarChart"}>
                    {this.props.t("report_bar_chart")}
                  </MenuItem>
                  <MenuItem key="fontSize" value={"LineChart"}>
                    {this.props.t("report_line_chart")}
                  </MenuItem>
                  <MenuItem key="fontSize" value={"PieChart"}>
                    {this.props.t("report_pie_chart")}
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">x</InputLabel>
                <Select
                  MenuProps={{
                    style: { zIndex: 10002 },
                  }}
                  value={
                    !this.state.chart.dataHeaders["x"]
                      ? ""
                      : this.state.chart.dataHeaders["x"]
                  }
                  onChange={this.handleSelectedDataNameChange("x")}
                  inputProps={{
                    name: "x",
                    id: "x",
                  }}
                >
                  {this.props.keys.map((key) => (
                    <MenuItem key="fontSize" value={key}>
                      {this.props.t("report_column_" + key).toUpperCase()}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">y</InputLabel>
                <Select
                  MenuProps={{
                    style: { zIndex: 10002 },
                  }}
                  value={
                    !this.state.chart.dataHeaders["y"]
                      ? ""
                      : this.state.chart.dataHeaders["y"]
                  }
                  onChange={this.handleSelectedDataNameChange("y")}
                  inputProps={{
                    name: "y",
                    id: "y",
                  }}
                >
                  {this.props.keys.map((key) => (
                    <MenuItem key="fontSize" value={key}>
                      {this.props.t("report_column_" + key).toUpperCase()}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography gutterBottom>
                  {this.props.t("report_chart_adjust_size")}
                </Typography>
                <div style={{ display: "flex" }}>
                  <TextField
                    style={{ marginRight: 10 }}
                    inputProps={{ min: "0" }}
                    type="number"
                    value={this.props.chart.width}
                    onChange={(e) => {
                      if (parseInt(e.target.value < 1)) return;
                      this.props.handleChartChange({
                        ...this.props.chart,
                        width: parseInt(e.target.value),
                      });
                    }}
                    label={this.props.t("report_chart_width")}
                  />
                  <TextField
                    inputProps={{ min: "0" }}
                    type="number"
                    value={this.props.chart.height}
                    onChange={(e) => {
                      if (parseInt(e.target.value) < 1) return;
                      this.props.handleChartChange({
                        ...this.props.chart,
                        height: parseInt(e.target.value),
                      });
                    }}
                    label={this.props.t("report_chart_height")}
                  />
                </div>
              </div>
              <FormControl component="fieldset" className={classes.formControl}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {this.state.edit && (
                    <Button
                      onClick={() =>
                        this.setState({
                          edit: false,
                          chart: {
                            ...this.state.chart,
                            title: "",
                            dataHeaders: {},
                          },
                        })
                      }
                      color="primary"
                      autoFocus
                    >
                      {this.props.t("global_cancel")}
                    </Button>
                  )}
                </div>
              </FormControl>
            </>
          ) : (
            <>
              {
                <>
                  <FormControl className={classes.formControl}>
                    <InputLabel id="report_groupby_label">
                      {this.props.t("report_group_by")}
                    </InputLabel>
                    <Select
                      MenuProps={{
                        style: { zIndex: 10002 },
                      }}
                      value={
                        this.props.groupByKey
                          ? this.props.groupByKey
                          : this.props.keys[0]
                      }
                      onChange={(e) => {
                        this.props.setGroupByKey(e.target.value);
                      }}
                      inputProps={{
                        name: "groupByKey",
                        id: "groupByKey",
                      }}
                    >
                      <MenuItem key={"none"} value="none">
                        {this.props.t("report_column_none").toUpperCase()}
                      </MenuItem>
                      {this.props.keys.map((key, index) => (
                        <MenuItem key={key + "-" + index} value={key}>
                          {this.props.t("report_column_" + key).toUpperCase()}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormGroup className={classes.formGroup}>
                    <FormLabel component="legend">
                      {this.props.t("report_summary_options")}
                    </FormLabel>
                    {this.props.groupByKey &&
                      this.props.groupByKey !== "none" && (
                        <FormControl>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.props.includeSummary}
                                onChange={(e) =>
                                  this.props.setIncludeSummary(e.target.checked)
                                }
                              />
                            }
                            label={this.props.t("report_include_summary_table")}
                          />
                        </FormControl>
                      )}
                    <FormControl>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.props.includeSummaryChart}
                            onChange={(e) =>
                              this.props.setIncludeSummaryChart(
                                e.target.checked
                              )
                            }
                          />
                        }
                        label={this.props.t("report_include_summary_chart")}
                      />
                    </FormControl>
                  </FormGroup>
                </>
              }
              <FormGroup
                className={classes.formGroup}
                id="column-choices-container"
              >
                <FormLabel component="legend">
                  {this.props.t("report_column_choices")}
                </FormLabel>
                {this.props.keys.map((key) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.props.usedKeys.includes(key)}
                        onChange={(e) =>
                          this.props.changedUsedKey(key, e.target.checked)
                        }
                      />
                    }
                    label={this.props.t("report_column_" + key).toUpperCase()}
                  />
                ))}
              </FormGroup>
            </>
          )}
        </div>
        <div style={{ width: "50%", display: "flex", flexDirection: "row" }}>
          <Divider orientation="vertical" />
          <div style={{ marginLeft: 8 }}>
            {table ? (
              <FormControl component="fieldset" className={classes.formControl}>
                <Table className={classes.table}>
                  <DragDropContext onDragEnd={this.onDragEnd}>
                    <TableHead>
                      <Droppable
                        droppableId="top-droppable"
                        type="top"
                        direction="horizontal"
                      >
                        {(dropProvided, dropSnapshot) => (
                          <TableRow
                            ref={dropProvided.innerRef}
                            {...dropProvided.droppableProps}
                          >
                            {this.props.usedKeys.map((key, index) => {
                              return (
                                <Draggable
                                  draggableId={"draggablechart" + index}
                                  index={index}
                                  key={key}
                                >
                                  {(dragProvided, dragSnapshot) => (
                                    <TableCell
                                      ref={dragProvided.innerRef}
                                      {...dragProvided.draggableProps}
                                    >
                                      {this.props
                                        .t("report_column_" + key)
                                        .toUpperCase()}
                                      <span
                                        className={`mdi mdi-drag-vertical`}
                                        {...dragProvided.dragHandleProps}
                                        style={{ fontSize: "1.5rem" }}
                                      />{" "}
                                    </TableCell>
                                  )}
                                </Draggable>
                              );
                            })}
                            {dropProvided.placeholder}
                          </TableRow>
                        )}
                      </Droppable>
                    </TableHead>
                  </DragDropContext>
                  <TableBody>{this.getRowsData()}</TableBody>
                </Table>
              </FormControl>
            ) : (
              <>
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                >
                  <ResizableBox
                    height={this.props.chart.height}
                    width={this.props.chart.width}
                    onResize={this.onResize}
                    resizeHandles={["se"]}
                  >
                    <div style={{ width: "100%", height: "100%" }}>
                      {this.returnChart()}
                    </div>
                  </ResizableBox>
                </FormControl>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
  onResize = (event, { element, size, handle }) => {
    this.props.handleChartChange({
      ...this.props.chart,
      width: Math.round(size.width),
      height: Math.round(size.height),
    });
  };
}
export default withTranslation()(withStyles(styles)(ChartStepThree));
